export default __webpack_public_path__ + "static/media/no-course-found.a33b48dd.jpg";